import React, { useState } from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import { NUMBER } from "../../../constants/app-constants";
import ArrowIcon from "../../shared/arrow";

const THRESHOLD = NUMBER.FOUR;

const StateEChallanList = ({
    data = {},
    threshold = THRESHOLD
}) => {

    const { title = "", sectionData = {} } = data || {};
    const { rows = [], columns = {} } = sectionData || {};

    const isListAboveThreshold = rows && rows.length > threshold;
    const filteredList = isListAboveThreshold ? rows.slice(0, threshold) : rows;
    const [showAll, setShowAll] = useState(false);

    const handleClick = () => {
        setShowAll((prev) => !prev);
    };

    const renderList = (list = []) => {

        const columnKeys = Object.keys(columns);

        if (!columnKeys.length || !list.length) return null;

        return (
            <ul styleName={"styles.list"}>
                <li styleName={"styles.listHeader"}>
                    {columnKeys.map((key) => (
                        <span key={`header-${key}`}>{columns[key]}</span>
                    ))}
                </li>
                {
                    list.map((row, rowIndex) => (
                        <li key={`row_${rowIndex}`} styleName={"styles.listText"}>
                            {columnKeys.map((key) => (
                                <span key={`cell-${rowIndex}-${key}`}>{row[key]}</span>
                            ))}
                        </li>
                    ))
                }
            </ul>
        );
    };

    if (rows && rows.length === NUMBER.ZERO) return null;

    return (
        <div styleName={"styles.listWrapper"} className="cvh">
            <h2>{title}</h2>
            {renderList(showAll ? rows : filteredList)}
            {
                isListAboveThreshold &&
                <div>
                    <span styleName={"styles.seeAllList"} onClick={handleClick}>View {showAll ? "Less" : "More"}</span>
                    <ArrowIcon rotateBy={showAll ? NUMBER.TWO_HUNDRED_SEVENTY : NUMBER.NINETY} onClick={handleClick} />
                </div>
            }
        </div>
    );
};

StateEChallanList.propTypes = {
    data: PropTypes.object,
    threshold: PropTypes.number
};

export default StateEChallanList;
